var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('audio',{attrs:{"id":"myAudio","src":_vm.SOUND_PATH}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }